<template>
    <div style="width: 100%; margin: 0 auto; background: #f5f5f5; margin-top: 0.7rem">
        <div class="container" :style="{ width: (route as any).query.activityType == 2 ? '11.4rem' : '10rem' }">
            <div v-if="!uploadSuccessShow" style="margin: 40px 0;  background: #fff; padding: 30px;border-radius: 12px;">
                <div style="font-size: 0.14rem; color: #333333; margin-bottom: 0.16rem;">
                    <el-icon @click="router.back()">
                        <Back />
                    </el-icon><span style="padding-left: 10px;">填写报名信息</span>
                </div>
                <div style="color: #86909C;">
                    <span>基本信息</span>
                </div>
                <el-radio-group v-if="(route as any).query.activityType == 2 && types_ == '1'" v-model="radio_type"
                    @change="radioChange" style="margin-top: 24px;margin-bottom: 4px;">
                    <el-radio value="1">个人报名</el-radio>
                    <el-radio label="2">团队报名</el-radio>
                </el-radio-group>
                <el-form ref="formRef" style="margin-top: 20px" inline :model="form" label-width="100px"
                    label-position="top" status-icon>
                    <el-form-item label="姓名" prop="realName" style="width: 225px;"
                        :rules='[{ required: true, message: "姓名不能为空", trigger: "blur" }]'>
                        <el-input v-model="form.realName" show-word-limit maxlength="6" placeholder="请输入姓名" />
                    </el-form-item>
                    <el-form-item label="手机号" prop="telphone" style="width: 225px;" :rules='[{
                        required: true, trigger: "blur", validator: checkPhone
                    }]'>
                        <el-input v-model="form.telphone" show-word-limit maxlength="11" placeholder="请输入手机号" />
                    </el-form-item>
                    <el-form-item label="电子邮箱" prop="email" style="width: 273px;"
                        :rules='[{ required: true, message: "电子邮箱不能为空", trigger: "blur" }, { validator: checkEmail, trigger: "blur" }]'>
                        <el-input v-model="form.email" show-word-limit maxlength="30" placeholder="请输入电子邮箱" />
                    </el-form-item>
                    <el-form-item v-if="(route as any).query.activityType == 2" style="width: 225px;" label="身份证号"
                        prop="idCardNumber" :rules='[{ required: true, message: "身份证号不能为空", trigger: "blur" }, {
                            validator: isCardId, trigger: "blur"
                        }]'>
                        <el-input v-model="form.idCardNumber" show-word-limit maxlength="30" placeholder="请输入身份证号" />
                    </el-form-item>
                    <div class="uploadForm_" v-if="radio_type == '2'">
                        <div style="color: #86909C;margin-bottom: 24px;">
                            <span>其他成员</span>
                        </div>
                        <div class="">
                            <div v-for="(item, index ) in   form.rests" :key="item.key"
                                style="display: flex;align-items: center;width: 100%;">
                                <el-form-item label="姓名" style="width: 225px;" :prop="'rests.' + index + '.realName'"
                                    :rules="('realName' + index) == 'realName0' ? [{ required: true, message: '姓名不能为空', trigger: 'blur' }] : []">
                                    <el-input v-model="item.realName" show-word-limit maxlength="6" placeholder="请输入姓名" />
                                </el-form-item>
                                <el-form-item label="手机号" style="width: 225px;" :prop="'rests.' + index + '.telphone'"
                                    :rules='("telphone" + index) == "telphone0" ? [{
                                        required: true, trigger: "blur", validator: checkPhone
                                    }] : [{
                                        required: false, validator: checkPhone_, trigger: "blur"
                                    }]'>
                                    <el-input v-model="item.telphone" show-word-limit maxlength="11" placeholder="请输入手机号" />
                                </el-form-item>
                                <el-form-item style="width: 273px;" label="电子邮箱" :prop="'rests.' + index + '.email'" :rules='("email" + index == "email0") ? [{ required: true, message: "电子邮箱不能为空", trigger: "blur" }, {
                                    validator: checkEmail, trigger: "blur"
                                }] : [{
                                    required: false, validator: checkEmail_, trigger: "blur"
                                }]
                                    '>
                                    <el-input v-model="item.email" show-word-limit maxlength="30" placeholder="请输入电子邮箱" />
                                </el-form-item>
                                <el-form-item style="width: 225px;" label="身份证号" :prop="'rests.' + index + '.identity'"
                                    :rules='("identity" + index == "identity0") ? [{ required: true, message: "身份证号不能为空", trigger: "blur" }, {
                                        validator: isCardId, trigger: "blur"
                                    }] : [{
                                        required: false, validator: isCardId, trigger: "blur"
                                    }]
                                        '>
                                    <el-input v-model="item.identity" show-word-limit maxlength="30"
                                        placeholder="请输入身份证号" />
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                    <div
                        style="height: 37px;line-height: 37px; color: #ff8741; font-weight: 400; font-size: 14px;padding-left: 8px;width: 100%;background: #ff874126;border-radius: 8px;margin-bottom: 5px;">
                        <span>填写报名信息后，即可上传参赛作品！</span>
                    </div>
                    <!-- <div class="uploadForm" v-if="(route as any).query.activityType != 2">
                        <div class="uploadTitle">
                            <span style="flex:1">上传报名表</span>
                            <a href="https://biaoshisx.com/template.doc"
                                style="width: 120px;color: #3fa4ed;cursor: pointer;"><el-icon>
                                    <Download />
                                </el-icon>下载报名表模板</a>
                        </div>
                        <div style="margin: 10px 0;">
                            <el-upload :file-list="fileList[0]" class="upload-demo" :action="upload_action"
                                accept=".doc,.docx"
                                :on-progress="(event: any, file: any, list: any) => handleProgress(0, list)"
                                :show-file-list="true" :on-success="(res: any, file: any, list: any) => onSuccess(0, res)">
                                <div
                                    style="border: 1px #3fa4ed solid;color: #3fa4ed;padding: 5px 10px; border-radius: 5px;">
                                    <el-icon>
                                        <Upload />
                                    </el-icon>
                                    <span>点击上传</span>
                                </div>
                            </el-upload>
                        </div>
                        <el-alert title="请上传按要求填写好的报名表" type="warning" :closable="false" />
                    </div> -->
                    <div class="" style="padding-bottom: 10px;font-size: 14px;display: flex;align-items: center;">
                        <el-checkbox v-model="radio1" label="" size="large" />
                        <span>我已同意大赛征集规则及</span>
                        <span style="color:#409eff;cursor: pointer;" @click="xzbtn">《活动须知》</span>
                        <span style="color: #606266;">所有条款</span>
                    </div>
                    <div style="display: block;width: 100%;">
                        <el-button type="primary" size="large" style="min-width: 280px;font-size:16px;height:45px;"
                            @click="submitForm">{{ (route as any).query.activityType == 2 ? "立即报名" : "下一步" }}</el-button>
                    </div>

                </el-form>
            </div>
            <!-- 提示 -->
            <div class="" v-if="uploadSuccessShow"
                style="width:10rem; height: 430px; margin: 0px auto;padding: 40px 0 20px;">
                <div
                    style="height:100%;background: #FFF;border-radius: 8px;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                    <img src="../../assets//success.png" style="width: 48px;height: 48px;" alt="" srcset="">
                    <div style=" color: #333333; font-size: 14px;margin-top: 16px;"><span>报名成功</span></div>
                    <div style="  color: #86909c; font-size: 14px;margin-top: 4px;"><span>已报名成功，可前往上传参赛作品</span></div>
                    <div style="display: flex;align-items: center;column-gap: 20px;margin-top: 24px;">
                        <div @click="backDetail"
                            style="width: 116px;height: 37px;text-align: center;line-height: 37px;border: 1px solid #2978FF;border-radius: 8px; color: #2978ff; font-size: 14px;cursor: pointer;">
                            <span>返回活动详情</span>
                        </div>
                        <div @click="jx"
                            style="width: 88px;height: 37px;text-align: center;line-height: 37px;background:#2978FF; border-radius: 8px; color: #FFF; font-size: 14px;cursor: pointer;">
                            <span>上传作品</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script lang="ts" setup>
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { ref, onBeforeMount, onMounted, nextTick, watch } from "vue";
import { serverBaseUrl } from "../../assets/js/ls_tgServerUrls.js";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { ElMessage } from "element-plus";
const upload_action = ref(serverBaseUrl + "/file/upload");
const route = useRoute();
const router = useRouter();
const formRef = ref(null);
const radio1 = ref("");
const uploadSuccessShow = ref(false);
const radio_type = ref("1");
const radioChange = (e: string) => {
    if (e == '2') {
        form.value.rests = [{
            key: 1,
            realName: "",
            telphone: "",
            email: "",
            identity: ""
        }, {
            key: 2,
            realName: "",
            telphone: "",
            email: "",
            identity: ""
        }]
    } else {
        form.value.rests = []
    }
    radio_type.value = e;
}
const form: any = ref({
    activityId: route.query.id,
    realName: undefined,
    telphone: undefined,
    email: undefined,
    joinFile: undefined,
    workFile: undefined,
    rests: [],
    idCardNumber: ""
});
const types_ = ref("");
const getInfo = function () {
    Axios("get", "/system/activity/" + route.query.id, null, false, function (res: any) {
        if (res.data.code == 200) {
            types_.value = String(res.data.data.otherType);
        } else {
            ElMessage.error(res.data.message);
        }
    });
};
(route as any).query.activityType == 2 && getInfo()
const backDetail = () => {
    router.back()
}
const jx = () => {
    router.push({
        path: "/AddMaterial",
        query: (route as any).query.activityType == 3 ? {
            activityId: route.query.activityId,
            id: route.query.id,
            activityType: 3
        } : { id: route.query.id, activityType: route.query.activityType }
    });
}
var isCardId = (rule, value, callback) => {
    if (value) {
        const reg =
            /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/;
        const card = reg.test(value);
        if (!card) {
            callback(new Error("身份证号格式有误！"));
        } else {
            callback();
        }
    } else {
        callback();
    }
    callback();
};
const checkPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('手机号不能为空'));
    } else {
        const reg = /^1[0-9]{10}$/
        if (reg.test(value)) {
            callback();
        } else {
            return callback(new Error('请输入正确的手机号'));
        }
    }
}
const xzbtn = () => {
    open('/agreement?name=hdxz', '_blank')
}
const checkPhone_ = (rule, value, callback) => {
    if (!value) return callback();
    const reg = /^1[0-9]{10}$/
    if (reg.test(value)) {
        callback();
    } else {
        return callback(new Error('请输入正确的手机号'));
    }
}
var checkEmail = (rule, value, cb) => {
    //验证邮箱的正则表达式
    const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
    if (regEmail.test(value)) {
        //合法的邮箱
        return cb();
    }
    //邮箱不合法
    cb(new Error('请输入合法的邮箱！'));
}
var checkEmail_ = (rule, value, cb) => {
    if (!value) return cb();
    //验证邮箱的正则表达式
    const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
    if (regEmail.test(value)) {
        //合法的邮箱
        return cb();
    }
    //邮箱不合法
    cb(new Error('请输入合法的邮箱！'));
}
// const rules = ref({
//     realName: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
//     telphone: [{
//         required: true, trigger: "blur", validator: checkPhone
//     }],
//     email: [{ required: true, message: "电子邮箱不能为空", trigger: "blur" }, { validator: checkEmail, trigger: 'blur' }]
// })
const fileList = ref([[], []])
const onSuccess = (idx: number, res: any) => {
    if (idx == 0)
        form.value.joinFile = res.data.url;
};
const handleProgress = (idx: number, list: any) => {
    fileList.value[idx] = list;
}
function submitForm() {
    formRef.value?.validate((valid, fields) => {
        if (valid) {
            // if ((route as any).query.activityType != 2 && !form.value.joinFile) {
            //     ElMessage.error('请上传报名表');
            //     return
            // }
            if (!radio1.value) {
                ElMessage.error('请勾选大赛征集规则等所有条款');
                return
            }
            form.value.type = radio_type.value;
            form.value.otherJson = JSON.stringify(form.value.rests.map((item: any, index: number) => {
                return {
                    realName: form.value.rests[index].realName,
                    telphone: form.value.rests[index].telphone,
                    email: form.value.rests[index].email,
                    identity: form.value.rests[index].identity,
                }
            }));
            Axios("post", "/system/activity-join", (route as any).query.activityType == 3 ? Object.assign(form.value, {
                activityId: route.query.activityId,
                taskId: route.query.id,
            }) : form.value, false, function (res) {
                if (res.data.code == 200) {
                    if ((route as any).query.activityType == 2) {
                        uploadSuccessShow.value = true;
                        return
                    }
                    router.push({
                        path: "/AddMaterial",
                        query: (route as any).query.activityType == 3 ? {
                            activityId: route.query.activityId,
                            id: route.query.id,
                            activityType: 3
                        } : { id: route.query.id, activityType: route.query.activityType }
                    });
                } else {
                    ElMessage.error(res.data.message);
                }
            });
        }
    });
}
</script>
<style scoped lang="less">
.container {
    width: 11.4rem;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;

    .uploadForm_ {
        // width: 8rem;
        display: flex;
        flex-direction: column;
        margin-top: 6px;
        margin-bottom: 14px;
    }

    .uploadForm {
        background: rgba(0, 0, 0, 0.06);
        display: flex;
        flex-direction: column;
        padding: 20px;
        border-radius: 10px;
        width: 8rem;
        margin-bottom: 10px;

        .uploadTitle {
            display: flex;
        }
    }
}

/deep/.el-form-item.is-success .el-input__suffix-inner {
    color: #67C23A !important;
}
</style>